import React from 'react';

interface HeroProps {
  heroSubtitle: string;
  isKindred?: boolean;
}

const Hero: React.FC<HeroProps> = ({ heroSubtitle, isKindred }) => {
  const heroSubtitles = heroSubtitle.split('\n\n');
  const singleLineSubtitle = heroSubtitle.replace(/\n\n/g, ' ');

  return (
    <div className="flex flex-row gap-4">
      {/* Name / Title */}
      <div className="flex-1 order-2">
        {isKindred ? (
          <>
            {/* Mobile: three lines */}
            <div className="block sm:hidden">
              <p className="text-3xl md:text-4xl font-normal sm:font-light text-gray-400">
                Hey, I'm
              </p>

              <h1 className="text-3xl md:text-4xl font-normal sm:font-light text-black">
                Theo Goodman
              </h1>

              <p className="text-3xl md:text-4xl font-normal sm:font-light -mb-8 text-gray-400">
                and I'd love to be a Staff PM at <span className="text-black">Kindred!</span>
              </p>
            </div>

            {/* Desktop: two lines, one sentence per line */}
            <div className="hidden sm:block">
              <p className="text-4xl md:text-5xl font-normal sm:font-light">
                <span className="text-gray-400">Hey, I'm </span>
                <span className="text-black">Theo Goodman</span>
              </p>
              <p className="text-4xl md:text-5xl font-normal sm:font-light mb-2 text-gray-400">
                and I'd love to be a Staff PM at <span className="text-black">Kindred!</span>
              </p>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-4xl md:text-6xl font-normal sm:font-light mb-2 text-black">
              Theo Goodman
            </h1>
            <h2 className="text-2xl md:text-2xl md:ml-2 font-light">
              {/* Mobile: Show as separate paragraphs */}
              <div className="block sm:hidden">
                {heroSubtitles.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              {/* Desktop: Show as single line */}
              <div className="hidden sm:block">{singleLineSubtitle}</div>
            </h2>
          </>
        )}
      </div>

      {/* Profile Image */}
      <div className="w-48 flex-shrink-0 order-1">
        <img 
          src="/images/theo.jpg" 
          alt="Theo Goodman - Software Developer, Product Manager and Co-founder of Half Lemons" 
          className="w-full h-48 object-cover rounded-3xl"
        />
      </div>
    </div>
  );
};

export default Hero; 